
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'HomePage',
    computed: {
      ...mapState({
        cms: state => state.cms.cms
      }),
      ...mapGetters({
        desktopBackground: 'cms/desktopBackground',
        mobileBackground: 'cms/mobileBackground',
        rightFloatingSupportIcon: 'cms/rightFloatingSupportIcon',
        rightFloatingMessageIcon: 'cms/rightFloatingMessageIcon',
        getSequenceAbleComponent: 'cms/getSequenceAbleComponent'
      }),
      sequenceComponentCmsForDesktop() {
        return [
          { name: 'Theme2DesktopHomeSlider', code: 'SliderContentDesktop' },
          { name: 'Theme2DesktopVideoContent1And2', code: 'VideoContent1' },
          { name: 'Theme2DesktopFeaturedContent1', code: 'FeaturedContent1' },
          { name: 'Theme2DesktopJackpotContent', code: 'JackpotContent' },
          { name: 'Theme2DesktopPromotionContent', code: 'PromotionContent' },
          { name: 'Theme2DesktopFeaturedContent2', code: 'FeaturedContent2' },
          { name: 'Theme2DesktopRecentWinners', code: 'RecentWinners' },
          { name: 'Theme2DesktopTopWinnerUnluckyWinner', code: 'TopWinners' },
          { name: 'Theme2DesktopFeaturedContent3', code: 'FeaturedContent3' },
          { name: 'Theme2DesktopRecommendedMatches', code: 'RecommendedMatches' },
        ]
      },
      dynamicSequenceComponentForDesktop() {
        const findMatchComponent = componentCode => {
          return this.getSequenceAbleComponent('desktop')?.find(
            el => el.component_code === componentCode && el.is_visible
          )?.sequence_desktop
        }
        return this.sequenceComponentCmsForDesktop
          .map(el => ({
            ...el,
            sequence: findMatchComponent(el.code) ?? 999 // fallback for missing sequence
          }))
          .sort((a, b) => parseFloat(a.sequence) - parseFloat(b.sequence))
      },
      sequenceComponentCmsForMobile() {
        return [
          { name: 'Theme2MobileHomeSlider', code: 'SliderContentMobile', model: false },
          { name: 'Theme2MobileVideoContent1And2', code: 'VideoContent1', model: false },
          { name: 'Theme2MobileFeaturedContent1', code: 'FeaturedContent1', model: false },
          { name: 'Theme2MobileJackpotContent', code: 'JackpotContent', model: false },
          { name: 'Theme2MobilePromotionContent', code: 'PromotionContent', model: false },
          { name: 'Theme2MobileFeaturedContent2', code: 'FeaturedContent2', model: false },
          { name: 'Theme2MobileFeaturedContent3', code: 'FeaturedContent3', model: false },
          { name: 'Theme2MobileRecommendedMatches', code: 'RecommendedMatches', model: false },
        ]
      },
      dynamicSequenceComponentForMobile() {
        const findMatchComponent = componentCode => {
          return this.getSequenceAbleComponent('mobile')?.find(
            el => el.component_code === componentCode
          )?.sequence_mobile
        }
        return this.sequenceComponentCmsForMobile
          .map(el => ({
            ...el,
            sequence: findMatchComponent(el.code) ?? 999 // fallback for missing sequence
          }))
          .sort((a, b) => parseFloat(a.sequence) - parseFloat(b.sequence))
      }
    },
    mounted() {
      // Call this store action only when the user is on the home page
      if (this.isMobileOnly()) {
        this.$store.dispatch('cms/homeCMS', { platform: 2 })
      }
      if (!this.isMobileOnly()) {
        this.$store.dispatch('cms/homeCMS', { platform: 1 })
      }
      if (!this.isMobileOnly()) {
        this.$store.dispatch('cms/footerCMS', { platform: 1 })
      }
      try {
        const session = window.sessionStorage
        const toggleFloating = session.getItem('toggleFloating')
        if (toggleFloating) {
          if (!this.isMainWebsite && this.rightFloatingMessageIcon.is_visible) {
            this.$nuxt.$emit('@toggleAgent', true)
          } else if (this.isMainWebsite && this.rightFloatingSupportIcon.is_visible) {
            this.$nuxt.$emit('@toggleSupport', true)
          } else if (this.isMainWebsite && this.rightFloatingMessageIcon.is_visible) {
            this.$nuxt.$emit('@toggleMessage', true)
          }
        }
        session.removeItem('toggleFloating')
      } catch (error) {}
    }
  }
